import { IconPropsType } from '..';

export const ResponsibleGamblingIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M10 0.5L2 4.03312C2 16.9663 10 20.5 10 20.5C10 20.5 18 16.9669 18 4.03312L10 0.5ZM11.0767 10.8169V14.9419H8.91475V10.8169C7.95096 10.3763 7.29143 9.40063 7.29143 8.26562C7.29152 7.76458 7.42302 7.27284 7.67206 6.84231C7.92111 6.41177 8.27846 6.05841 8.7064 5.81949C9.13435 5.58058 9.61703 5.46497 10.1035 5.48488C10.59 5.50479 11.0622 5.65946 11.4704 5.93259C11.8785 6.20572 12.2075 6.58717 12.4226 7.0367C12.6376 7.48622 12.7307 7.98715 12.6922 8.48662C12.6536 8.9861 12.4847 9.4656 12.2034 9.87452C11.9221 10.2835 11.5387 10.6066 11.0938 10.81L11.0767 10.8169Z" />
  </svg>
);
